import React from 'react'
import PropTypes from 'prop-types'
import { Table as AntdTable } from 'antd'
import { classNames } from 'utils/utils'
import { isString, isFalse } from 'utils/types'
import strings from 'utils/strings'
import { SMALL, DEFAULT } from 'constants/ui'
import withStyle, { TableHeader } from './Table.style.js'

const HEADING_TYPE = {
  [SMALL]: 'h4',
  [DEFAULT]: 'h3',
}

const Table = ({
  className,
  dataSource,
  rowClassName,
  columns,
  yScroll,
  xScroll,
  pagination,
  onRow,
  size,
  rowKey,
  bordered,
  rowSelection,
  title,
  onChange,
  pageSize,
  defaultExpandAllRows,
  expandable,
  noResultText,
  plain, // eslint-disable-line no-unused-vars
  ...rest
}) => {
  const scroll = {
    ...(yScroll && { y: yScroll }),
    ...(xScroll && { x: xScroll }),
  }

  const rowClass = isString(rowClassName)
    ? classNames(rowClassName, 'chec-table-row')
    : (record, index) =>
        classNames(`chec-table-row ${rowClassName(record, index)}`)

  const itemRender = (current, type, originalElement) => {
    const { total } = pagination
    if (type === 'prev' && current === 0) return <></>
    if (type === 'next' && current === Math.ceil(total / dataSource.length))
      return <></>
    return originalElement
  }

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total}`

  const customPagination = isFalse(pagination)
    ? false
    : {
        showTotal,
        itemRender,
        pageSize,
        ...pagination,
      }

  return (
    <div className={className}>
      {title && <TableHeader type={HEADING_TYPE[size]}>{title}</TableHeader>}
      <AntdTable
        rowSelection={rowSelection}
        bordered={bordered}
        pagination={customPagination}
        onRow={onRow}
        size={size}
        rowKey={rowKey}
        className={'chec-table'}
        dataSource={dataSource}
        columns={columns}
        scroll={scroll}
        rowClassName={rowClass}
        onChange={onChange}
        locale={noResultText || { emptyText: strings.no_results }}
        defaultExpandAllRows={defaultExpandAllRows}
        {...expandable}
        {...rest}
      />
    </div>
  )
}

Table.defaultProps = {
  rowClassName: '',
  size: 'default',
  pagination: false,
  title: null,
  onChange: () => {},
  pageSize: 10,
  rowSelection: null,
  showEmptyText: true,
  plain: false,
}

Table.propTypes = {
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  bordered: PropTypes.bool,
  rowSelection: PropTypes.object,
  rowClassName: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  // TODO define column object shape
  yScroll: PropTypes.number,
  xScroll: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  onRow: PropTypes.func,
  size: PropTypes.string,
  rowKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onChange: PropTypes.func,
  pageSize: PropTypes.number,
  showEmptyText: PropTypes.bool, // style prop
  plain: PropTypes.bool,
  defaultExpandAllRows: PropTypes.bool,
  expandable: PropTypes.object,
  noResultText: PropTypes.object,
}

export default withStyle(Table)
